import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import classnames from 'classnames';
import Attribute from 'marketing/common/attribute';
import Dropdown from 'common/components/dropdown_menu';

export default class Hero extends Component {
  constructor(props) {
    super(props);

    this.state = { imageIdx: -1 };

    this.updateImage = this.updateImage.bind(this);
  }

  componentDidMount() {
    /* set image to be displayed and also the timer to update it periodically if
       there's more than 1 */
    const { images=[], image_interval=5000 } = this.props;
    this.timer = images.length > 1? setInterval(this.updateImage, image_interval) : null;
    this.updateImage();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  updateImage() {
    const { images=[] } = this.props;
    this.setState({ imageIdx: (this.state.imageIdx + 1) % images.length })
  }

  renderDropdown() {
    const { dropdown } = this.props;

    if (!dropdown) {
      return null;
    }

    const buttons = dropdown.buttons.map(b => ({
      ...b,
      show: true,
      action: () => {},
      toggleOnClick: !b.url,
      closeOnClick: !!b.url,
      extraBtnClasses: b.extraBtnClasses || "btn btn-tertiary"
    }));

    return (
      <div className="hero-actions">
        <Dropdown className="with-buttons" showFirst={true} buttons={buttons} />
      </div>
    );
  }

  renderCta() {
    const { cta } = this.props;

    if (!cta) {
      return null;
    }

    return (
      <div className="hero-actions">
        { cta.type === "button" && !cta.link.startsWith("#") &&
        <Link to={cta.link} className="btn btn-primary">
          { cta.label }
        </Link> }

        { cta.type === "button" && cta.link.startsWith("#") &&
        <a href={cta.link} className="btn btn-primary">
          { cta.label }
        </a> }

        { cta.type !== "button" &&
        <Link to={cta.link} className="btn btn-text">
          { cta.label } <i className="fa fa-long-arrow-right"/>
        </Link> }
      </div>
    );
  }

  render() {
    const {
      title, blurb_html, subtitle, className, images=[], full_width_text,
      longer_width_text
    } = this.props;
    const { imageIdx } = this.state;
    const sectionClasses = classnames('block block-hero', {
      'full-width-text': full_width_text
    }, className);
    const textClasses = classnames("small-16 columns", {
      "medium-8": !full_width_text && !longer_width_text,
      "medium-12 medium-offset-2": full_width_text,
      "medium-10": longer_width_text
    });
    const imageClasses = classnames("small-16 columns", {
      "medium-8": !longer_width_text,
      "medium-6": longer_width_text,
    });

    return (
      <section className={sectionClasses}>
        <div className="row">
          <div className={textClasses}>
            <h1 className="hero-title">{title}</h1>

            { !!subtitle &&
            <div className="hero-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} /> }

            <div className="hero-text" dangerouslySetInnerHTML={{ __html: blurb_html }} />

            { this.renderCta() }

            { this.renderDropdown() }
          </div>
          { !full_width_text &&
          <div className={imageClasses}>
            {images.map((image, i) => (
              <div key={i} className={classnames('hero-image', { 'active': i === imageIdx })}>
                <img src={image.url} alt={image.alt}/>
                {image.attribute &&
                  <Attribute to={image.attribute}/>
                }
              </div>
            ))}
          </div> }
        </div>
      </section>);
  }
};

Hero.propTypes = {
  title: PropTypes.string,
  blurb_html: PropTypes.string,
  images: PropTypes.array,
  image_interval: PropTypes.number,
  subtitle: PropTypes.string,
  cta: PropTypes.object,
  className: PropTypes.string,
  full_width_text: PropTypes.bool,
  longer_width_text: PropTypes.bool,
  dropdown: PropTypes.object,
};
